// extracted by mini-css-extract-plugin
export default {"menu":"menu--w8J4C"};